import { PermissionsActionsModel } from "../models/models/permissionsActionsModel";

export const PermissionsActions: PermissionsActionsModel = {
    edit: false,
    add: false,
    export: true,
    filter: true,
    delete: false
  };